import React, { useCallback } from 'react';
import { IconButton } from '@material-ui/core';

import { ChevronRightIcon } from '../../icon/solid';

type Props = {
  changePage: (page: number) => void;
  page: number;
  pages: number;
};

const NextPageAction = ({ changePage, page, pages }: Props) => {
  const onChange = useCallback(() => {
    changePage(page + 1);
  }, [changePage, page]);

  return (
    <IconButton onClick={onChange} disabled={page + 1 === pages || pages === 0}>
      <ChevronRightIcon />
    </IconButton>
  );
};

export default NextPageAction;
